<template>
    <DVCAPointCalculator />
</template>

<script>
// @ is an alias to /src
import DVCAPointCalculator from "@/components/DVCAPointCalculator.vue";

export default {
    name: "Home",
    components: {
        DVCAPointCalculator,
    },
};
</script>
